var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("base-tutorial", { attrs: { steps: _vm.steps } }, [
    _c("div", [
      _c("h2", [
        _vm._v("Olá! Vamos começar a avaliação comportamental da sua equipe?"),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Analise os comportamentos da sua equipe")]),
      _c("p", [
        _vm._v(
          " Os comportamentos aparecerão na sua tela e, logo abaixo, aparecerá o nome de cada pessoa que trabalha no seu setor. Ao lado de cada nome, aparecerá uma escala que vai de "
        ),
        _c("span", { staticClass: "info--text" }, [_vm._v('"Nunca"')]),
        _vm._v(" a "),
        _c("span", { staticClass: "info--text" }, [_vm._v('"Sempre"')]),
        _vm._v(". "),
      ]),
    ]),
    _c("div", [
      _c("h2", [
        _vm._v("Analise a frequência dos comportamentos da sua equipe"),
      ]),
      _c("p", [
        _vm._v(
          " Clique na estrela que representa a frequência que o membro da sua equipe apresentou o comportamento indicado durante o período estabelecido. "
        ),
      ]),
      _c("p", [
        _c("span", { staticClass: "error--text" }, [_vm._v("Atenção!")]),
        _vm._v(
          ", Caso você apresente, no período avaliado, motivos que impeçam a avaliação dos pares, clique em "
        ),
        _c("span", { staticClass: "info--text" }, [
          _vm._v("“Não é possível avaliar”"),
        ]),
        _vm._v(" e selecione uma das opções indicadas. "),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Importante!")]),
      _c("p", { staticClass: "info--text" }, [
        _vm._v(
          " Lembre-se! Você deverá avaliar os membros da sua equipe que trabalham no mesmo turno e espaço físico que você. Essa avaliação nos ajudará a construir a trilha de desenvolvimento da sua unidade. "
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }